import { Menu as MuiMenu } from '@mui/material';
import type { MenuProps as MuiMenuProps } from '@mui/material';

export type MenuProps = MuiMenuProps;

/** Menu item component to render items in the menu list. Gets primary background on hover. Based on MUI MenuItem: https://mui.com/material-ui/api/menu/ */
export const Menu = (props: MenuProps) => <MuiMenu {...props} />;
